import { createListenerMiddleware } from '@reduxjs/toolkit';

import { routes } from '~constants/routes';
import { events, sendEvent } from '~features/annals';
import { deleteDefaultPromocode } from '~features/promocode';
import { lsKeys } from '~features/storage';
import { botsApi } from '~services/api/bots';
import { creditsApi } from '~services/api/credits';
import { WebPushService } from '~services/webpush';
import { TokenManager } from '~shared/services/ClientTokenManager';
import { removeToken } from '~utils/token';

import type { AppDispatch, RootState } from '../index';
import { logout } from '../utils/logout';

export const userData = createListenerMiddleware();
//update bot list after buying
userData.startListening({
	matcher: creditsApi.endpoints.buyBot.matchFulfilled,
	effect: (action, listenerApi) => {
		const userId = action.meta.arg.originalArgs.id;
		void listenerApi.dispatch(
			botsApi.endpoints.getBotsAvailability.initiate(userId, {
				forceRefetch: true,
			})
		);
	},
});
// logout, clear user data
userData.startListening({
	actionCreator: logout,
	effect: async (_, listenerApi) => {
		const redirectedTo = routes.explore.home;
		const redirectedFrom = window.location.toString();
		const userId = (listenerApi.getState() as RootState).auth.info.id;
		await sendEvent({
			userId,
			event: events.common.userRedirected,
			body: {
				redirected_from: redirectedFrom,
				redirect_to: redirectedTo,
				timestamp: (Date.now() / 1000) | 0,
			},
		});
		void WebPushService(listenerApi).unsubscribeWebPush();
		deleteDefaultPromocode();
		TokenManager.clearToken('main');
		// TODO: Remove usqge in next releases
		await removeToken();
		window.localStorage.clear();
		window.localStorage.setItem(lsKeys.FORCE_MODE_SWITCH, 'true');
		window.location.replace(redirectedTo);
	},
});

//update contacts after getting exact profile
userData.startListening({
	matcher: botsApi.endpoints.getBotProfile.matchFulfilled,
	effect: (action, listenerApi) => {
		const { recipientId, userId } = action.meta.arg.originalArgs;
		const data = action.payload;
		void listenerApi.dispatch(
			botsApi.util.updateQueryData('getContacts', { userId }, (draft) => {
				if (data && !draft.contacts[recipientId]) {
					draft.contacts[recipientId] = {
						...data,
						lastMessage: null,
						unreadMessagesCount: 0,
						totalMessagesCount: 0,
						generations: [],
						isTyping: false,
					};
				}
			}) as AppDispatch
		);
	},
});
